import {API_URL} from "@/shared/lib/api";
import {
    CancelReservationData,
    CancelReservationResponse,
    ClientCRM,
    SaveOrderData,
    SaveOrderResponse,
    SaveReservationData,
    SaveReservationResponse
} from "@/features/types/StatusChangeInterface";

export const saveOrderAction = async (data: SaveOrderData): Promise<SaveOrderResponse['data']> => {
    const res = await fetch(`${API_URL}/index.php?action=save-order-action`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! Status: ${res.status}`);
    }

    const result: SaveOrderResponse = await res.json();
    if (!result.success || !result.data) {
        throw new Error("Błąd podczas zapisywania danych");
    }

    return result.data;
};

export const saveReservationAction = async (data: SaveReservationData): Promise<SaveReservationResponse> => {
    const res = await fetch(`${API_URL}/index.php?action=save-reservation-action`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! Status: ${res.status}`);
    }

    const result: SaveReservationResponse = await res.json();
    if (!result.success) {
        throw new Error("Błąd podczas zapisywania rezerwacji");
    }

    return result;
};

export const cancelReservationAction = async (data: CancelReservationData): Promise<CancelReservationResponse> => {
    const res = await fetch(`${API_URL}/index.php?action=cancel-reservation-action`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! Status: ${res.status}`);
    }

    const result: CancelReservationResponse = await res.json();
    if (!result.success) {
        throw new Error("Błąd podczas anulowania rezerwacji");
    }

    return result;
};

export const searchClientsCRM = async (query: string, limit: number = 20): Promise<ClientCRM[]> => {
    const res = await fetch(`${API_URL}/index.php?action=search-order-clients`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify({query, limit}),
    });

    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
    // Backend zwraca już zmapowane aliasy (tak jak w getAutoTableUnion)
    return await res.json();
};
